import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    padding: "12px",
    backgroundColor: theme.palette.white.main,
  },
  listItem: {
    color: theme.palette.secondary.main,
    padding: "12px",
    margin:"0px !important",
    "&:hover": {
      borderRadius: "4px",
      backgroundColor: theme.palette.gray2.main,
    },
    "& i": {
      color: theme.palette.secondary.tint15,
      marginLeft: "12px",
    },
  },
  text: {
    minWidth: "110px",
    fontSize: "12px",
  },
}));
